import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserProvider';
import PropTypes from 'prop-types';
import LoadingScreen from './LoadingScreen';
import { onAuthStateChange } from '../firebase';

const ALLOWED_ROUTES = ['/about', '/terms', '/contact', '/policy'];

function PublicRoute({ children }) {
  const location = useLocation();
  const { user: kipUser } = useUser();
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChange((user) => {
      setFirebaseUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  if (ALLOWED_ROUTES.includes(location.pathname)) {
    return children;
  }

  if ((firebaseUser || kipUser) !== null) {
    return <Navigate to="/home" />;
  }

  return children;
}

PublicRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PublicRoute;
